import React from 'react';

export const VerticalContext = React.createContext('news');
